import DesktopHeader from './desktop/DesktopHeader';
import MobileHeader from './mobile/MobileHeader';
import { Desktop, Mobile } from '../../helpers/MediaQueries';

const Header = ({ route, location, dark }) => (
	<div id="responsive-header">
		<Desktop>
			<DesktopHeader {...{ location, dark, route }} />
		</Desktop>
		<Mobile>
			<MobileHeader {...{ location, route }} />
		</Mobile>
	</div>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/Header.js